const groupListByField = (list, field) => {
  const groupedLists = {}
  list.forEach((item) => {
    const fieldValue = item[field]
    if (!groupedLists[fieldValue]) {
      groupedLists[fieldValue] = []
    }
    groupedLists[fieldValue].push(item)
  })

  return groupedLists
}

export { groupListByField }
